/*
 * @Author: 赵泽文
 * @Date: 2022-05-25 14:25:48
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-05-30 14:00:12
 * @Description: 出品率报表model
 */

import type {
  IFinishedRateReportModel,
  IFinishedRateReportStore,
} from '@monorepo/types/process/finishedRateReport/finishedRateReport.types';
import { getToday } from '@monorepo/utils';

const initState: IFinishedRateReportStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    sort_order: 'PLAN_FINISHED_RATE_DESC',
    date_type: 'AUDIT_DATE',
    date: getToday(),
  },
};

const finishedRateReport: IFinishedRateReportModel = {
  namespace: 'finishedRateReportStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default finishedRateReport;
